import { createContext } from "react";

export interface GalleryContext {
  // filterArg can be used to specify which collection of files to open; e.g. for a particular flight id
  openGallery: (filterArg: string, fileId: string) => void;
  closeGallery: () => void;
  getContainer: () => HTMLElement | null;
  splitSizes: number[];
  setSplitSizes: (sizes: number[]) => void;
}

export const galleryContext = createContext<GalleryContext>({
  openGallery: () => {},
  closeGallery: () => {},
  getContainer: () => null,
  splitSizes: [],
  setSplitSizes: () => {},
});
